import { z } from 'zod/mini'

import { gtmMetadataShape } from './gtm-metadata'
import { itemSchema } from './item'
import { nonEmptyString } from './non-empty-string'

export const viewItemSchema = z.strictObject({
  ...gtmMetadataShape,
  event: z.literal('view_item'),
  ecommerce: z.strictObject({
    currency: nonEmptyString(),
    value: z.number().check(z.gt(0)),
    items: z.array(
      z.strictObject({
        ...itemSchema.shape,
        item_is_trade_in_eligible: z.boolean(),
      }),
    ),
  }),
})
